import { subMonths } from 'date-fns';
export var getFirstDayOfCurrentMonth = function (date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
};
export var getSixMonthsAgoDate = function (firstDay) { return subMonths(firstDay, 6); };
var filterStatements = function (statements) {
    var todayDate = new Date();
    var firstDayOfCurrentMonth = getFirstDayOfCurrentMonth(todayDate);
    var sixMonthsAgoDate = getSixMonthsAgoDate(firstDayOfCurrentMonth);
    if (!statements) {
        return [];
    }
    return statements.filter(function (statement) {
        return new Date(statement.statementDate) > new Date(sixMonthsAgoDate);
    });
};
export default filterStatements;
//# sourceMappingURL=filter-statements.js.map